require("dotenv").config();

const config = {
  dev: process.env.NODE_ENV !== "production",
  authJwtSecret: process.env.VUE_APP_AUTH_JWT_SECRET,
  publicApiKeyToken: process.env.VUE_APP_PUBLIC_API_KEY_TOKEN,
  adminApiKeyToken: process.env.VUE_APP_ADMIN_API_KEY_TOKEN,
};

module.exports = { config };
